module.exports = "//public.zight.com/packs/media/images/onboarding/icons-chrome-5bc9d1d53ebb20106c6b2c1c728cc1cf.svg";